import styled, { css } from 'styled-components';
import { RGBColor } from 'react-color';
import { visuallyHidden } from '../../styles/mixins';
import { vars } from '../../theme';

const ColorPickerWrapper = styled.div`
    /* Fixes the vertical scroll issue  */
    overflow: hidden;
    width: 215px;
    padding: 5px 5px 10px;
    box-sizing: border-box;
    background: ${vars.colors.surface.container};
    border: none;
    border-radius: ${vars.radius.md};
    box-shadow: ${vars.shadow['40']};
`;

const ColorControls = styled.div`
    display: flex;
    margin-top: 15px;
`;

const HueAlphaWrapper = styled.div`
    width: 100%;
    margin-left: 6px;
`;

const ColorCircle = styled.div<{
    backgroundColor: RGBColor | string;
    isSquare?: boolean;
}>`
    position: relative;
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: ${vars.radius.full};
    overflow: hidden;
    border: solid 2px ${vars.colors.stroke.secondary};
    cursor: pointer;
    background-color: ${({ backgroundColor: color }) =>
        typeof color === 'string'
            ? color
            : `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`};

    ${({ isSquare }) =>
        isSquare &&
        css`
            border-radius: ${vars.radius.xs};
            width: 44px;
            height: 44px;
            flex-shrink: 0;
            cursor: default;
        `}
`;

const SelectedColorCircle = styled.div<{
    isSelected: boolean;
}>`
    display: inline-block;
    border-radius: ${vars.radius.full};
    margin-right: 4px;
    padding: 2px;
    border: solid 2px
        ${({ isSelected }) =>
            isSelected ? vars.colors.base.accent : 'transparent'};
`;

const EmptyColorCircle = styled.div`
    background-color: ${vars.colors.surface.item};
    width: 24px;
    height: 24px;
    box-sizing: border-box;
    border-radius: ${vars.radius.full};
    overflow: hidden;

    ::after {
        width: 2px;
        content: '';
        height: 24px;
        margin-left: 8px;
        background-color: ${vars.colors.base.danger};
        display: inline-block;
        transform: rotate(45deg);
    }
`;

const ControlersWrapper = styled.div`
    padding: 0 12px 0 6px;
`;

const AlphaWrapper = styled.div`
    position: relative;
    height: 9px;
    width: 100%;
    margin-top: 10px;
`;

const HueWrapper = styled.div`
    position: relative;
    height: 9px;
    width: 100%;
`;

const SaturationWrapper = styled.div`
    position: relative;
    height: 112px;
`;

const SaturationPicker = styled.div`
    height: 7px;
    width: 7px;
    background-color: ${vars.colors.surface.itemInverted};
    border-radius: ${vars.radius.full};
    border: 1px solid ${vars.colors.surface.item};
`;

const CircleWrapper = styled.div`
    position: relative;

    span {
        div {
            border: solid 1px ${vars.colors.stroke.secondary};
            box-sizing: border-box;
            border-radius: ${vars.radius.full};

            span {
                div {
                    border: none;
                    /* box-shadow: rgb(255, 244, 68) 0px 0px 0px 12px inset; */
                    div {
                        box-shadow: none !important;
                    }
                }
            }
        }
    }
`;

const ColorPickerButtonWrapper = styled.div`
    position: absolute;
    position: absolute;
    right: -88px;
    top: 30px;
`;

const Label = styled.div`
    font-family: ${vars.fonts.body};
    font-size: 12px;
    font-weight: 400;
    line-height: 1.17;
    text-transform: uppercase;
    margin-bottom: 10px;
    color: ${vars.colors.text.tertiary};
`;

const CustomPointer = styled.div`
    width: 13px;
    height: 13px;
    box-shadow: ${vars.shadow['20']};
    background-color: ${vars.colors.surface.item};
    border-radius: ${vars.radius.full};
    margin-top: -2.5px;
    margin-left: -6.5px;
`;

const EditableInputWrapper = styled.div`
    position: relative;
    width: 100%;
    margin: 15px 0;

    input {
        width: 172px;
        border-radius: ${vars.radius.sm};
        background-color: ${vars.colors.surface.itemInset};
        font-family: ${vars.fonts.body};
        font-size: 14px;
        line-height: 1.43;
        color: ${vars.colors.text.secondary};
        border: none;
        padding: 3px 8px;
    }

    span {
        display: none;
    }

    label {
        ${visuallyHidden}
    }
`;

const ColorPickerActionsContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-top: 20px;
`;

export {
    ColorPickerWrapper,
    AlphaWrapper,
    ColorCircle,
    ColorPickerButtonWrapper,
    HueAlphaWrapper,
    ColorControls,
    HueWrapper,
    SaturationWrapper,
    CircleWrapper,
    EditableInputWrapper,
    Label,
    ControlersWrapper,
    CustomPointer,
    EmptyColorCircle,
    SelectedColorCircle,
    SaturationPicker,
    ColorPickerActionsContainer
};
